export function getScreenCordinates(element) {
  const cordinates = {};
  cordinates.x = element.offsetLeft;
  cordinates.y = element.offsetTop;
  while (element.offsetParent) {
    cordinates.x = cordinates.x + element.offsetParent.offsetLeft;
    cordinates.y = cordinates.y + element.offsetParent.offsetTop;
    if (element === document.getElementsByTagName("body")[0]) {
      break;
    } else {
      element = element.offsetParent;
    }
  }
  return cordinates;
}
